<template>
  <div class="blog-grid grid">
    <div class="col-12 p-0">
      <title-view variant="primary ">
        Bliss Blog
      </title-view>
    </div>

    <div class="col-12 pagination-mobile">
      <pagination
        v-model="page"
        :records="articles.length"
        :per-page="perPage"
        :options="options"
      />
    </div>

    <div
      v-for="(article, index) of displayedRecords"
      :key="index"
      class="col-4_sm-6_xs-12 article-list"
      @click="goToDetails(article.slug)"
    >
      <blog-card-view>
        <template slot="image">
          <img :src="article.imageUrl">
        </template>

        <template slot="date">
          {{ article.date }}
        </template>

        <template slot="title">
          {{ article.title }}
        </template>

        <template slot="text">
          {{ article.smallTitle }}
        </template>

        <template slot="tags">
          {{ article.tags }}
        </template>
      </blog-card-view>
    </div>
    <div class="col-12">
      <pagination
        v-model="page"
        :records="articles.length"
        :per-page="perPage"
        :options="options"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import Pagination from 'vue-pagination-2';
import PaginationView from '@/components/pagination';
import ENVIRONMENT from '@/env';

Vue.component('Pagination', Pagination);

export default {
  name: 'BlogGrid',

  components: {
    BlogCardView: () => import('@/components/blog/blog-card-view'),
    TitleView: () => import('@/components/title/title-view')
  },

  data() {
    return {
      page: 1,
      perPage: 9,
      options: {
        template: PaginationView
      }
    };
  },

  computed: {
    ...mapState('articles', {
      articles: (state) => state.articles
    }),

    baseUrl() {
      return ENVIRONMENT.baseUrl;
    },

    displayedRecords() {
      const startIndex = this.perPage * (this.page - 1);
      const endIndex = startIndex + this.perPage;
      return this.articles.slice(startIndex, endIndex);
    }

  },

  mounted() {
    this.getArticles();
  },

  methods: {
    ...mapActions('articles', [
      'getArticles'
    ]),

    goToDetails(slug) {
      this.$router.push({ name: 'blog_detail', params: { id: slug } });
    }
  }

};
</script>

<style lang="scss" src="@/assets/components/blog/blog-grid-view.scss"></style>



// WEBPACK FOOTER //
// blog-grid-view.vue